import { performGetRequest } from '@atlassian/jira-fetch';
import catchAndLogFetchError from '@atlassian/jira-project-settings-apps-common/src/util/catch-and-log-fetch-error';
import type { AccessLevel } from '@atlassian/jira-shared-types';

export type ProjectAccessValueResponse = {
	value: AccessLevel;
	displayName: string;
	iconName: string;
	description: string;
};

type ProjectAccessValueService = {
	getProjectAccessValue(baseUrl: string, projectId: number): Promise<ProjectAccessValueResponse>;
};

export const getProjectAccessLevelUrl = (baseUrl: string, projectId: number): string =>
	`${baseUrl}/rest/internal/simplified/1.0/accesslevel/project/${String(projectId)}`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const toProjectAccessValue = (json: any): ProjectAccessValueResponse => json;

const projectAccessValueService: ProjectAccessValueService = {
	getProjectAccessValue: (baseUrl, projectId): Promise<ProjectAccessValueResponse> =>
		catchAndLogFetchError(
			performGetRequest(getProjectAccessLevelUrl(baseUrl, projectId)),
			'Failed to fetch project access level',
		).then(toProjectAccessValue),
};

export default projectAccessValueService;
